import { NewPasswordContainer } from "Containers/AuthContainer/NewPasswordContainer/NewPassword";
export const NewPassword = () => {
  return <NewPasswordContainer />;
};
